export default "__VITE_ASSET__DJuiu0Zi__"